import { render, staticRenderFns } from "./InquiryRequestListLiew.vue?vue&type=template&id=4705ef33&scoped=true"
import script from "./InquiryRequestListLiew.vue?vue&type=script&lang=js"
export * from "./InquiryRequestListLiew.vue?vue&type=script&lang=js"
import style0 from "./InquiryRequestListLiew.vue?vue&type=style&index=0&id=4705ef33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4705ef33",
  null
  
)

export default component.exports